import { useMemo } from 'react';
import { useAuth } from '../../auth/context/AuthContext';
import { PermissionCodes } from '../../auth/permissions';

export const useRosteringAccess = () => {
  const { auth, hasPermission } = useAuth();

  const myEmployeeId = useMemo(
    () => auth?.employeeId ?? null,
    [auth?.employeeId],
  );

  const canManageAll = hasPermission([PermissionCodes.rosteringManageAll]);
  const canManageOwn = hasPermission([PermissionCodes.rosteringManage]);
  const canView = hasPermission([
    PermissionCodes.rosteringRead,
    PermissionCodes.rosteringManage,
    PermissionCodes.rosteringManageAll,
  ]);

  const canEditEmployee = (employeeId: string) => (
    canManageAll || (canManageOwn && Boolean(myEmployeeId) && employeeId === myEmployeeId)
  );

  const canViewEmployee = (employeeId: string) => (
    canManageAll || (Boolean(myEmployeeId) && employeeId === myEmployeeId)
  );

  return {
    myEmployeeId,
    canManageAll,
    canManageOwn,
    canView,
    canEditEmployee,
    canViewEmployee,
  };
};
